import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/commerce/checkout/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(data.payment_status)) { setState("error"); return; }
      } catch (e) { /* keep polling */ }
      if (tries < 8) setTimeout(poll, 2000); else setState("pending");
    };
    poll();
  }, [sid]);

  return (
    <div className="p-10 max-w-md mx-auto text-center" data-testid="payment-success-page">
      <div className="tc-card p-8">
        {state === "checking" && (<><Loader2 className="w-8 h-8 mx-auto animate-spin text-tc-coach" /><p className="text-tc-sub mt-3">Confirming your subscription…</p></>)}
        {state === "paid" && (<>
          <CheckCircle2 className="w-10 h-10 mx-auto text-tc-bull" />
          <h1 className="font-heading text-2xl font-bold mt-3">You're upgraded</h1>
          <p className="text-tc-sub mt-2">Your entitlement is active. Remember: capabilities that require earned competency (and guardian authorization for minors) still apply.</p>
          <button data-testid="ps-continue" onClick={() => navigate("/dashboard")} className="mt-5 rounded-lg bg-tc-coach text-tc-bg font-semibold px-6 py-2.5">Go to TODAY</button>
        </>)}
        {state === "pending" && (<>
          <Loader2 className="w-8 h-8 mx-auto text-tc-mastery" />
          <p className="text-tc-sub mt-3">Payment received — your subscription is syncing. This can take a moment.</p>
          <button onClick={() => navigate("/account")} className="mt-4 rounded-lg border border-white/15 px-5 py-2 text-tc-sub">View billing</button>
        </>)}
        {state === "error" && (<>
          <XCircle className="w-10 h-10 mx-auto text-tc-bear" />
          <p className="text-tc-sub mt-3">We couldn't confirm a payment. No charge was completed.</p>
          <button onClick={() => navigate("/pricing")} className="mt-4 rounded-lg border border-white/15 px-5 py-2 text-tc-sub">Back to plans</button>
        </>)}
      </div>
    </div>
  );
}
